import Request from './request';

async function fetch(data) {
    return Request('get', "api/licences/index",data);
}


async function add(data) {
    return Request('post', "api/licences/add", data);
}

async function edit(data) {
    return Request('post', "api/licences/edit" , data);
}

async function Delete(id) {
    return Request('get', "api/licences/delete/" + id);
}

export default {
    fetch, 
    add,
    edit,
    Delete,
};